import { Checkboxes } from 'nhsuk-react-components';
import { FormEventHandler } from 'react';

interface CheckboxItemProps {
  id: string;
  label: string;
  value?: string | string[];
  checked: boolean;
  onChange?: FormEventHandler<HTMLInputElement>;
  isLabelVisible?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export function CheckboxItem({
  id,
  label,
  value,
  checked,
  onChange,
  isLabelVisible = true,
}: CheckboxItemProps) {
  const displayValue = Array.isArray(value) ? value.join(', ') : value;
  return (
    <Checkboxes.Item
      id={id}
      checked={Boolean(checked)}
      onChange={(event) => {
        if (onChange) {
          onChange(event);
        }
      }}
      aria-label={label}
    >
      {label && isLabelVisible ? (
        <p className="nhsuk-u-font-weight-bold nhsuk-u-margin-1">
          {label}
          :
        </p>
      ) : null}
      {displayValue ? <p className="nhsuk-u-margin-1">{displayValue}</p> : null}
    </Checkboxes.Item>
  );
}
